export const BetrGrKV = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine KV',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'allgemein',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'erhöht',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'ermäßigt',
  },
  {
    'PAISY Wert': 5,
    Bezeichnung: 'landwirtsch.',
  },
  {
    'PAISY Wert': 6,
    Bezeichnung: 'pauschal GFB',
  },
  {
    'PAISY Wert': 9,
    Bezeichnung: 'Firmenzahler',
  },
];
